import { ScreenTrigger, ScreenType, Step } from '@frontend/wizard/types';
import { useEffect } from 'react';

import { useOpenDropOff } from '../../hooks/useOpenDropOff';
import { useWizardTransaction } from '../../hooks/useWizardTransaction';
import { useScreen } from '../useScreen';

interface ViewProps {
    pinStep?: Step;
    scanStep?: Step;
    itsmeStep?: Step;
    falseStep?: Step;
    onOpenDropoff: () => void;
    onContinue: (nextStep?: Step | undefined) => void;
    onBack: (type: ScreenType) => void;
}

const useDropOffMethod = (): ViewProps => {
    const { store, onBack, onSubmit: onContinue } = useScreen();
    const { isOpenDropOffEnabled, enterOpenDropOff } = useOpenDropOff();
    const transactionContext = useWizardTransaction({
        wizardId: store!.wizard.id,
        store,
        autoCreate: false,
        autoFetch: false
    });

    useEffect(() => {
        transactionContext.localUpdateTransaction({ feature: store?.functionality.feature });
    }, []);

    const falseStep =
        isOpenDropOffEnabled && store?.steps
            ? store.steps.find((step) => step.screen === ScreenType.DROP_OFF_METHOD && step.trigger === ScreenTrigger.SUBMIT_FALSE)
            : undefined;

    const onOpenDropoff = async () => {
        if (!falseStep || !store) return;

        const settings = await enterOpenDropOff();
        if (!settings) return;

        onContinue(falseStep);
    };

    return {
        pinStep: store?.steps.find(
            (step) => step.screen === ScreenType.DROP_OFF_METHOD && step.trigger === ScreenTrigger.SUBMIT && step.next_screen === ScreenType.DROP_OFF_PIN_CODE
        ),
        scanStep: store?.steps.find(
            (step) =>
                step.screen === ScreenType.DROP_OFF_METHOD && step.trigger === ScreenTrigger.SUBMIT && step.next_screen === ScreenType.DROP_OFF_SCAN_QR_CODE
        ),
        itsmeStep: store?.steps.find(
            (step) =>
                step.screen === ScreenType.DROP_OFF_METHOD && step.trigger === ScreenTrigger.SUBMIT && step.next_screen === ScreenType.ITSME_QR_AUTHENTICATION
        ),
        falseStep,
        onOpenDropoff,
        onContinue,
        onBack
    };
};

export default useDropOffMethod;
